import agendaApiConfig from "./agendaApiConfig";
import ManageStorage from 'src/shared/global/manageStorage';

const procedimientoService = {

    async getServicios() {

        let query =  {}; 

        return await agendaApiConfig.get(`/agenda-servicio`);
    },
    async getProcedimientos(cod) {
        let query =  {}; 
        query.SER_CODIGO = "PCD"; 

        return await agendaApiConfig.get(`/agenda-procedimiento/${cod}`, {
            params: {
                ...query
            }
        });
    }

}

export default procedimientoService